import { render, staticRenderFns } from "./DormRoomFeatures.vue?vue&type=template&id=7fb39970&scoped=true&"
import script from "./DormRoomFeatures.vue?vue&type=script&lang=js&"
export * from "./DormRoomFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb39970",
  null
  
)

export default component.exports